import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0b792ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Duplicar", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_perfil_usuario = _resolveComponent("selecionar-perfil-usuario")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_painel_fluxo = _resolveComponent("painel-fluxo")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_selecionar_icone_processo_vendas = _resolveComponent("selecionar-icone-processo-vendas")!
  const _component_etapa_processo_vendas_modal = _resolveComponent("etapa-processo-vendas-modal")!
  const _component_selecionar_etapa_processo_vendas_modal = _resolveComponent("selecionar-etapa-processo-vendas-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_processo_vendas_ordenacao_etapas_modal = _resolveComponent("processo-vendas-ordenacao-etapas-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    center: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      (_ctx.state.telaMobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Cad. de Processos de Vendas")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Cadastro de Processos de Vendas")
          ], 64)),
      _createVNode(_component_a_switch, {
        style: {"float":"right","padding-top":"1px"},
        checked: _ctx.state.processo.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.processo.ativo) = $event))
      }, {
        checkedChildren: _withCtx(() => [
          _createVNode(_component_icone, { nome: "play-preenchido" })
        ]),
        unCheckedChildren: _withCtx(() => [
          _createVNode(_component_icone, { nome: "pause-preenchido" })
        ]),
        _: 1
      }, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_spin, {
              spinning: _ctx.state.carregandoEtapas,
              size: "small"
            }, {
              default: _withCtx(() => [
                (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-lg ant-btn-secondary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.duplicarRegistro && _ctx.duplicarRegistro(...args)))
                    }, _hoisted_3))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "DADOS PRINCIPAIS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (_ctx.telaBase.empresasDisponiveis.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_a_form_item, {
                                label: "Empresas",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_empresa, {
                                    varias: true,
                                    empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                    codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                    "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                                  }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Nome",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.processo.nome) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.processo.nome]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Responsável",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_usuario, {
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigoSelecionado: _ctx.state.processo.codigoResponsavel,
                                "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.processo.codigoResponsavel) = $event))
                              }, null, 8, ["empresas", "codigoSelecionado"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Perfis de Usuários",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_perfil_usuario, {
                                varios: true,
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigosSelecionados: _ctx.perfisUsuarios,
                                "onUpdate:codigosSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.perfisUsuarios) = $event))
                              }, null, 8, ["empresas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Usuários",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_usuario, {
                                varios: true,
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigosSelecionados: _ctx.usuarios,
                                "onUpdate:codigosSelecionados": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.usuarios) = $event))
                              }, null, 8, ["empresas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_form_item, {
                            label: "Padrão Frente Caixa",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.processo.padraoFrenteCaixa,
                                "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.processo.padraoFrenteCaixa) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "ETAPAS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_spin, {
                        spinning: _ctx.state.carregandoEtapas,
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_painel_fluxo, {
                            altura: 250,
                            largura: 980,
                            titulo: "Etapas",
                            cards: _ctx.state.fluxoEtapas,
                            editavel: !_ctx.state.possuiVendas,
                            onAdicionar: _ctx.adicionarEtapa,
                            onEditar: _ctx.editarEtapa,
                            onExcluir: _ctx.excluirEtapa
                          }, {
                            menusadicionais: _withCtx(() => [
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Ordenar Etapas"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    class: "ant-btn ant-btn-secondary",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.abrirOrdenacaoEtapas && _ctx.abrirOrdenacaoEtapas(...args)))
                                  }, [
                                    _createVNode(_component_icone, {
                                      style: {"margin-top":"4px"},
                                      nome: "ordenacao"
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["cards", "editavel", "onAdicionar", "onEditar", "onExcluir"])
                        ]),
                        _: 1
                      }, 8, ["spinning"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_selecionar_icone_processo_vendas, {
        visivel: _ctx.state.exibirSelecaoIcones,
        "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.exibirSelecaoIcones) = $event)),
        icone: _ctx.state.processo.icone,
        "onUpdate:icone": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.processo.icone) = $event))
      }, null, 8, ["visivel", "icone"]),
      _createVNode(_component_etapa_processo_vendas_modal, {
        ultimoCodigoProvisorio: _ctx.state.ultimoCodigoProvisorio,
        "onUpdate:ultimoCodigoProvisorio": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.ultimoCodigoProvisorio) = $event)),
        visivel: _ctx.state.exibirDetalheEtapa,
        "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.exibirDetalheEtapa) = $event)),
        editavel: !_ctx.state.possuiVendas,
        etapasAnteriores: _ctx.state.etapasAnteriores,
        etapa: _ctx.state.etapaSelecionada,
        onConfirmacao: _ctx.atualizarEtapa
      }, null, 8, ["ultimoCodigoProvisorio", "visivel", "editavel", "etapasAnteriores", "etapa", "onConfirmacao"]),
      _createVNode(_component_selecionar_etapa_processo_vendas_modal, {
        etapa: _ctx.state.etapaSelecionada,
        visivel: _ctx.state.exibirSelecionarEtapa,
        "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.exibirSelecionarEtapa) = $event)),
        onConfirmacao: _ctx.transferirVendasEtapaExcluida
      }, null, 8, ["etapa", "visivel", "onConfirmacao"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_processo_vendas_ordenacao_etapas_modal, {
        visivel: _ctx.state.exibirOrdenacaoEtapas,
        "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.exibirOrdenacaoEtapas) = $event)),
        etapas: _ctx.state.processo.etapas,
        "onUpdate:etapas": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.processo.etapas) = $event))
      }, null, 8, ["visivel", "etapas"])
    ]),
    _: 1
  }, 8, ["visible"]))
}